import { render, staticRenderFns } from "./fitExchange.vue?vue&type=template&id=05621b62&scoped=true&"
import script from "./fitExchange.vue?vue&type=script&lang=ts&"
export * from "./fitExchange.vue?vue&type=script&lang=ts&"
import style0 from "./fitExchange.vue?vue&type=style&index=0&id=05621b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05621b62",
  null
  
)

export default component.exports